/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fullscreen_medium'
export default icon
